import { SpaTreatment } from './SpaTreatment';

export default SpaTreatment;
